import React from 'react';
import IconHeadphones from '../svg/Icon_Headphones';
import IconGlowingObjectOutline from '../svg/Icon_Glowing_Object_Outline';
import IconExplicit from '../svg/Icon_Explicit';

const ExploreIconRow = () => {
    return (
        <div id='explore-icon-row' class='explore-icon-row'>
            <div>
                <div class='icon arrows'><span><img src='/assets/svgs/chev.svg'></img></span><span><img src='/assets/svgs/chev.svg'></img></span></div>
                <div class='text'>
                    Click to move through the rooms sequentially.
                </div>
            </div>
            <div>
                <div class='icon map'><span><img src='/assets/svgs/map.svg'></img></span><small>Map</small></div>
                <div class='text'>
                    Or use the floor map to jump around.
                </div>
            </div>
            <div>
                <div class='icon duck'><img src='/assets/svgs/duck-fill.svg'></img><img src='/assets/svgs/duck-outline.svg'></img></div>
                <div class='text'>
                    Select glowing objects to hear archival audio.
                </div>
            </div>
            <a class='explore-cta' href='/explore/threshold'>Enter</a>
        </div>
    )
}

export default ExploreIconRow;